var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"m-error-page"},[_c('div',{staticClass:"m-error-page__img",class:'m-error-page__img--' + _vm.type}),_c('div',{staticClass:"m-error-page__txt"},[_vm._v(_vm._s(_vm.content))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }